/* eslint-disable react/jsx-props-no-spreading */
import React, { ComponentProps, FC } from 'react';

import * as Icons from '../icons';
import { spacing } from '../spacing';

type IconNames = keyof typeof Icons;
type SVGRIconProps = ComponentProps<(typeof Icons)['Spinner']>; // Picking a random icon to grab the props off of
export interface IconProps extends SVGRIconProps {
  /** True, if the icon should be animated. */
  animated?: boolean;
  /** The duration of the animation, if icon is animated. (e.g. "0.9s"). */
  animationDuration?: string | number;
  /**
   * The name of the icon to render.
   */
  name: IconNames;
  /** The size of the icon to render. */
  size?: keyof typeof spacing;
}

const Icon: FC<IconProps> = ({ name, size, animationDuration = '0.9s', animated, ...props }) => {
  const Component = Icons[name];

  const iconSize = React.useMemo(() => (size ? spacing[size] : undefined), [size]);
  if (iconSize) {
    return <Component dur={animated ? animationDuration : undefined} height={iconSize} width={iconSize} {...props} />;
  }
  return <Component dur={animated ? animationDuration : undefined} {...props} />;
};

export { Icon };
